import { EventTypes, track } from '@mc/track-event'

export const trackTileClicked = (link) => {
  track(EventTypes.HOMEPAGE_CLICK, {
    action: 'click',
    category: 'trending',
    link,
    location: 'announcements',
  })
}
